import { render, staticRenderFns } from "./GoodsSelect.vue?vue&type=template&id=2f1ebeac&scoped=true&"
import script from "./GoodsSelect.vue?vue&type=script&lang=ts&"
export * from "./GoodsSelect.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsSelect.vue?vue&type=style&index=0&id=2f1ebeac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ebeac",
  null
  
)

export default component.exports